/**
 * Date-extensions locale Portuguese (Brazil) [pt-br]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('pt-br', {
    monthNames: ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
    monthShortNames: ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'],
    dayNames: ['Domingo','Segunda-feira','Terça-feira','Quarta-feira','Quinta-feira','Sexta-feira','Sábado'],
    dayShortNames: ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb']
});
